import React, {useCallback} from 'react';
import {Box} from '@mui/material';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {useTranslation} from 'react-i18next';

interface DateFilterProps {
  startDate: Date | null;
  onChangeDate: (date: Date) => void;
  pastEvents: boolean;
}

const DateFilter: React.FC<DateFilterProps> = ({
  startDate,
  onChangeDate,
  pastEvents
}) => {
  const {t} = useTranslation();

  const handleStartDateChange = useCallback(
    (date: Date | null) => {
      if (date) {
        onChangeDate(date);
      }
    },
    [onChangeDate]
  );

  return (
    <Box
      sx={{
        width: '100%'
      }}
    >
      <DatePicker
        label={t('date')}
        value={startDate ? new Date(startDate) : null}
        onChange={handleStartDateChange}
        disablePast={pastEvents ? false : true}
        disableFuture={pastEvents ? true : false}
        sx={{width: '100%'}}
      />
    </Box>
  );
};

export default DateFilter;
